import * as React from 'react';
import { Elements, Link as PrismicLink, RichTextSpan } from 'prismic-reactjs';
import { getLocalUrlIfLiveOneUsed } from '@utils/language';
import LinkTranslated from './LinkTranslated';

/**
 * Custom serializer for hyperlinks in Prismic rich text fields.
 * Converts hyperlinks to `LinkTranslated`, enhancing them with attribute
 * like `targetBlank` when applicable.
 *
 * @param {Elements} type - The element type to be serialized.
 * @param {RichTextSpan} element - The element data containing the hyperlink.
 * @param {React.ReactNode} content - The content of the hyperlink.
 * @param {React.ReactNode} _children - The child nodes of the hyperlink.
 * @param {string} key - The unique key for React's rendering.
 * @returns {React.ReactNode} The serialized hyperlink element.
 */
const PrismicLinkSerializer = (type: Elements, element: RichTextSpan, content: React.ReactNode, _children: React.ReactNode, key: string) => {
  if (type === Elements.hyperlink) {
    const url = PrismicLink.url(element?.data);
    const finalUrl = getLocalUrlIfLiveOneUsed(url);

    return (
      <LinkTranslated key={key} to={finalUrl} targetBlank={element?.data?.target === '_blank'}>
        {content}
      </LinkTranslated>
    );
  }

  // Return null for unhandled types
  return null;
};

export default PrismicLinkSerializer;
